import { BagHoldIcon, BagPersonalItemIcon, CabinTrolleyIcon, CancellationPartiallyRefundableIcon, FastTrackIcon, FoodIcon, HealthInsuranceIcon, PlaneTicketReturnIcon, SeatRegularIcon } from "@bookingcom/bui-assets-react/streamline";
export const includedBaggageIcons = {
    PERSONAL_ITEM: BagPersonalItemIcon,
    HAND: CabinTrolleyIcon,
    CHECKED_IN: BagHoldIcon
};
export const productIcons = {
    checkedInBaggage: BagHoldIcon,
    specialBag: BagHoldIcon,
    specialBags: BagHoldIcon,
    cabinBaggage: CabinTrolleyIcon,
    cabinBaggagePerTraveller: CabinTrolleyIcon,
    personalItem: BagPersonalItemIcon,
    flexibleTicket: PlaneTicketReturnIcon,
    travelInsurance: HealthInsuranceIcon,
    mealChoice: FoodIcon,
    mealPreference: FoodIcon,
    seatingBesides: SeatRegularIcon,
    seatingPreference: SeatRegularIcon,
    seatMapSelection: SeatRegularIcon,
    seatMap: SeatRegularIcon,
    cancelForAnyReason: CancellationPartiallyRefundableIcon,
    fastTrack: FastTrackIcon,
    customerServiceExtraProduct: PlaneTicketReturnIcon
};
